// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VMgGN","header":"styles_header__Cef5B","description":"styles_description__Ev6Vn","active":"styles_active__sB8zN"};